import React, { createContext, useContext } from 'react';
import { authApi } from '../services/api/auth';
import { clearSessionAndRedirectToLogin } from '../services/api/onAuthFailure';

type SignOutFn = () => Promise<void>;

const legacySignOut: SignOutFn = async () => {
  try {
    await authApi.logout();
  } finally {
    clearSessionAndRedirectToLogin();
  }
};

export const SignOutContext = createContext<SignOutFn>(legacySignOut);

export const SignOutProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => (
  <SignOutContext.Provider value={legacySignOut}>{children}</SignOutContext.Provider>
);

export function useSignOut(): SignOutFn {
  return useContext(SignOutContext);
}
